import CartLoader from './cart-loader';

export default class SamplesPage {
  //===========================================================================
  // Construct your class
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {};

      this.reset();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Sets/Resets the PDP
  //===========================================================================

  reset() {
    this.setState();
    this.adjustStickyFooter();
  }

  //===========================================================================
  // Sets the state
  //===========================================================================

  setState() {
    this.state.$section = $('.js-free-samples');
    this.state.$stickyFooter = $('.js-free-samples-footer');
  }

  //===========================================================================
  // Adds a sample to the cart
  //===========================================================================

  onSampleSelection(e) {
    const $target = $(e.currentTarget);
    const variantId = $target.val();
    let payload;

    if ($target.is('a')) {
      e.preventDefault();
    }

    if (variantId) {
      this.state.$section.addClass('loading');

      payload = {
        id: variantId,
        quantity: 1,
        properties: {
          _free_samples: true,
          _free_sample_promotion: true
        }
      };

      new CartLoader({ payload: payload, callback: this.sampleCallback.bind(this) });
    }
  }

  //===========================================================================
  // Removes a sample from the cart
  //===========================================================================

  onSampleUnselect(e) {
    const $target = $(e.currentTarget);
    const lineNum = $target.data('line');
    const self = this;

    if ($target.is('a')) {
      e.preventDefault();
    }

    if (lineNum) {
      this.state.$section.addClass('loading');

      CartJS.updateItem(lineNum, 0, {}, {
        "success": function(data) {
          self.sampleCallback(true);
        },
        "error": function(err) {
          self.sampleCallback(true);
          alert('There was an error updating your cart.');
        }
      });
    } else {
      $(document).trigger('cartRefresh');
    }
  }

  //===========================================================================
  // Callback function after a sample is added/removed from cart
  //===========================================================================

  sampleCallback(refreshCart) {
    const self = this;
    const href = document.location.href;

    $.ajax({
      url: href,
      type: 'GET',
      dataType: 'html',
      success: function(data) {
        if (data) {
          self.refreshTemplate(data);

          if (refreshCart) {
            $(document).trigger('cartRefresh');
          }
        } else {
          document.location.href = href;
        }

        if (refreshCart) {
          $(document).trigger('cartRefresh');
        }

        self.state.$section.removeClass('loading');
      },
      error: function() {
        document.location.href = href;
      }
    });
  }

  //===========================================================================
  // Refreshes the page template if the cart drawer quantities are changed
  //===========================================================================

  onCartDrawerUpdate() {
    if (this.state.$section[0]) {
      this.sampleCallback();
    }
  }

  //===========================================================================
  // Refreshes the page template
  //===========================================================================

  refreshTemplate(data) {
    const $templateBody = $(`<div>${ data }</div>`);
    const $templateContent = $templateBody.find('.js-free-samples .js-free-samples-products');
    const $templateFooter = $templateBody.find('.js-free-samples-footer');
    const $content = this.state.$section.find('.js-free-samples-products');
    const $footer = this.state.$stickyFooter;

    $content.html($templateContent.html());
    $footer.html($templateFooter.html());
    $(document).trigger('resetGrids');
  }

  //===========================================================================
  // Shows or hides the sticky footer.
  //===========================================================================

  adjustStickyFooter() {
    if (this.state.$section[0]) {
      const bounds = this.state.$section[0] ? this.state.$section[0].getBoundingClientRect() : null;
      const $body = $('body');

      if (bounds && bounds.top < (window.innerHeight - 100)) {
        this.state.$stickyFooter.addClass('active');
        $body.addClass('hide-widgets');
      } else {
        this.state.$stickyFooter.removeClass('active');
        $body.removeClass('hide-widgets');
      }
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-sample-checkbox', this.onSampleSelection.bind(this));
    $(document).on('click', '.js-sample-uncheckbox', this.onSampleUnselect.bind(this));
    $(document).on('cartDrawerQtyChange', this.onCartDrawerUpdate.bind(this));
    $(document).on('historyChange', this.reset.bind(this));
    $(window).on('resize', this.adjustStickyFooter.bind(this));
    $(window).on('scroll', this.adjustStickyFooter.bind(this));
  }
}
